import React from "react";
import SwitchInput from "../../../core/form/SwitchInput";

let PartnerEnabledField = (props) => {

    return <SwitchInput
        name='enabled'
        label='form.partner.enabled'
        {...props}
    />

}

export default PartnerEnabledField